import React from 'react';
import * as Yup from 'yup';
import { EditorState, convertToRaw } from 'draft-js'
import language from '../languages';

const meta = (lang) => { 
    return {
        entityName: language[lang].Page,
        entityTitle: language[lang].Pages,
        emptyRow: () => {
            return {
                title: '',
                slug: '',
                content: JSON.stringify(convertToRaw(EditorState.createEmpty().getCurrentContent())),
                isActive: true
            }
        },
        collection: 'pages',
        hideTitle: true,
        addButtonText: language[lang].New_Page,
        // addButtonText: () => {
        //     return <>Add New </>
        //     },
        fields: [
            {name: 'title', default: null, dataType: 'string', label: 'Title', input: 'text'},
            {name: 'slug', default: null, dataType: 'string', label: 'Slug', input: 'text'},
            {name: 'isActive', default: true, dataType: 'boolean', label: 'Status', input: 'switch', color: 'primary'},
            {name: 'content', default: null, dataType: 'string', label: 'Content', input: 'editor'}
        ],
        table: [
            {name: 'title', type: 'field', label: 'Title'},
            {name: 'slug', type: 'field', label: 'Slug'},
            {name: 'isActive', type: 'conditionField', label: 'Status', textForTrue: 'Active', textForFalse: 'Inactive'},
            {name: 'actions', type: 'action', label:'Actions', actions: ['delete', 'edit']}
        ],
        validationSchema: Yup.object({
            title: Yup.string()
                .required(language[lang].Field_Required),
            slug: Yup.string()
                .required(language[lang].Field_Required),
        }),
        filterObject: [],
        defaultOrderBy: ['title', 'asc'],
        searchableColumns: ['title','slug'],
        beforeSave: (user, doc)=> {
            return doc
        }
    }
}

export default meta;